
import { createContext, ReactNode, useState } from "react";
import { useBoolean } from '@fluentui/react-hooks';


interface AiContextType {
  isAiToolsVisible: boolean;
  showAiTools: () => void;
  hideAiTools: () => void;
}

interface AiContextProviderProps {
  children: ReactNode;
}

export const AiContext = createContext({} as AiContextType)

export function AiContextProvider({ children }: AiContextProviderProps) {
  const [isAiToolsVisible, { setTrue: showAiTools, setFalse: hideAiTools }] = useBoolean(false);

  return (
    <AiContext.Provider value={{
      isAiToolsVisible,
      showAiTools,
      hideAiTools,
    }}>
      {children}
    </AiContext.Provider>
  )
}